import { CurrencyKztIcon } from './CurrencyKztIcon';

/**
 * author: Augustin Ursu
 * id FDA284E5-BF4A-47DC-B68F-255E07DB89CF
 * name currency-kzt
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-kzt.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const KazakhstaniTengeIcon = CurrencyKztIcon;
export default KazakhstaniTengeIcon